import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { useEffect } from 'react'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'
import styled, { ThemeProvider } from 'styled-components'
import { ChartCh } from 'components/chartCh'
import { ReactElement } from 'react'
import { ChartEvolution } from 'components/chartEvolution'
import SwissChartScrolly from 'components/SwissChartScrolly'
import CanvasScrolly from 'components/CanvasScrolly'
import Header from 'components/Header'
import {
  ChartTitle,
  ChartDescription,
  ChartAnnotations,
  ChartNotes,
} from 'components/styles'
import { useTranslation } from 'react-i18next'
import '../../i18n'

// MAIN: https://www.24heures.ch/et-si-nos-riches-payaient-davantage-pour-le-climat-347025086713?preview_key=9627b06ed7b1bfe05cd074d78a2d3d9b
// ITW: https://www.24heures.ch/la-crise-climatique-est-aussi-une-question-sociale-651437041227?preview_key=f471aaf29ed10f8702a19b5115913ae7

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const { t, i18n } = useTranslation()
  const theme = {
    backgroundColor: colorMode === 'dark' ? '#27252e' : '#27252e',
    colorMain: colorMode === 'dark' ? '#7A3F77' : '#7A3F77',
    grayColor: colorMode === 'dark' ? '#000000' : '#f5f6f7',
    blue: colorMode === 'dark' ? '#5a64a8' : '#202346',
    chartGridColorX: colorMode === 'dark' ? '#333344' : '#eeeeee',
    chartGridColorY: colorMode === 'dark' ? '#444455' : '#cccccc',
    colorMode: colorMode,
    brandColor:
      tenant.key === '24heures'
        ? colorMode == 'dark'
          ? '#f65861'
          : '#d9010e'
        : colorMode == 'dark'
        ? '#6570c1'
        : '#2c3890',
  }

  const modules: { [key: string]: ReactElement } = {
    intro: (
      <CanvasScrolly
        title={properties?.title as string}
        keywords={properties?.keywords as string}
        date={properties?.date as string}
        authors={properties?.authors as string}
        lead={properties?.lead as string}
      />
    ),
    header: (
      <Header
        title={properties?.title}
        keywords={properties?.keywords}
        lead={properties?.lead}
        date={properties?.date}
        authors={properties?.authors}
      />
    ),
    test: <div>TEST</div>,
    chChart: <SwissChartScrolly />,
    worldChart: (
      <>
        <TextWidth>
          <ChartAnnotations>
            <ChartTitle>{t('worldChart:title')}</ChartTitle>
            <ChartDescription>{t('worldChart:lead')}</ChartDescription>
          </ChartAnnotations>
        </TextWidth>
        <ContentWidth>
          <ChartCh />
        </ContentWidth>
        <TextWidth>
          <ChartNotes>
            {/* <p>
              Les données tiennent compte des émissions issues de la
              consommation domestique, des investissements publics et privés et
              des imports et exports de marchandises et services échangés avec
              le reste du monde.
            </p> */}
            <p>{t('main:source')}: World Inequality Report</p>
          </ChartNotes>
        </TextWidth>
      </>
    ),
    evolutionChart: (
      <>
        <TextWidth>
          <ChartAnnotations>
            <ChartTitle>{t('evolutionChart:title')}</ChartTitle>
            <ChartDescription>{t('evolutionChart:lead')}</ChartDescription>
          </ChartAnnotations>
        </TextWidth>
        <ContentWidth>
          <ChartEvolution />
        </ContentWidth>
        <TextWidth>
          <ChartNotes>{t('main:source')}: World Inequality Report</ChartNotes>
        </TextWidth>
      </>
    ),
  }

  useEffect(() => {
    i18n.changeLanguage(tenant.lang)
  }, [tenant])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ThemeProvider theme={theme}>{modules[properties?.module as string]}</ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 4rem;
`

export default MainComponent
